import axios from "axios";
import users from "assets/JSONs/HRDemoData/users.json";
import session from "assets/JSONs/HRDemoData/session.json";
import hr_overview from "assets/JSONs/HRDemoData/hr_overview.json";
import store from "../store/store";

export const loadAllTherapyTypes = async (token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/therapyTypes",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const loadAllFeatures = async (token) =>
  await axios.get(process.env.REACT_APP_SERVER_URI + "/api/sendAllFeatures", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const loadAllProblemTypes = async (token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/problemTypes",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const loadAllAvatars = async () =>
  await axios.get(process.env.REACT_APP_SERVER_URI + "/api/avatar");

export const saveaftercallratingapi = async (data) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/aftercallrating",
    data
  );

export const fetchTherapistBookings = async (
  { type = "", page = "", month = "", year = "", timeOffset = 0 },
  token
) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      `/api/bookings/therapist?type=${type}&page=${page}&month=${month}&year=${year}&timeOffset=${timeOffset}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const fetchTherapistClients = async ({ pageParam }, token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      `/api/therapist/clients?page=${pageParam}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const fetchOnboardingStatus = async (token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + `/api/therapist/onboarding-status`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const submitOnboarding = async (data, token) =>
  await axios.patch(
    process.env.REACT_APP_SERVER_URI + `/api/therapist/complete-onboarding`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getTherapistClientDetails = async ({ clientID }, token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + `/api/therapist/client/${clientID}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getTherapistClientTasks = async (clientId, token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      `/api/therapist/client/${clientId}/tasks`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getClientCaseNotes = async (clientId, token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + `/api/listCaseNotes?userId=${clientId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const submitClientNewTasks = async (clientId, newTasks, date, token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI +
      `/api/therapist/client/${clientId}/tasks`,
    { date: date, tasks: newTasks },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const fetchUserBookings = async (
  { month = "", year = "", timeOffset = 0, type = "all" },
  token
) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      `/api/bookings/user?type=${type}&month=${month}&year=${year}&timeOffset=${timeOffset}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const fetchLatestBooking = async (token) =>
  await axios.get(process.env.REACT_APP_SERVER_URI + `/api/latestBooking`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const loadAllPaymentPlans = async (token, therapistId = "") =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/paymentPlans",
    therapistId ? { therapistId } : {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const walletSessionsInfo = async (token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + "/api/walletSessionsInfo",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getRepeatUsers = async (
  token,
  adminCorporateId,
  department,
  location,
  timeRange,
  customDateRange
) => {
    try {
      let url = process.env.REACT_APP_SERVER_URI +
      `/api/loginSessions/${adminCorporateId}?teamLocation=${location}&teamName=${department}&timeRange=${timeRange}`;

    // Add custom range if timeRange is "custom" and customDateRange is provided
    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(e);
      throw e;
    }
};

export const getClientUsers = async (
  token,
  adminCorporateId,
  department,
  location,
  timeRange,
  customDateRange
) => {
    try {
      let url = process.env.REACT_APP_SERVER_URI +
          `/api/clientUsers/${adminCorporateId}?teamLocation=${location}&teamName=${department}&timeRange=${timeRange}`;

    // Add custom range if timeRange is "custom" and customDateRange is provided
    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }
      const response = await axios.get(
       url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(e);
      throw e;
    }
};

export const getB2BSessionInfo = async (token, adminCorporateId) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      "/api/B2BSessionInfo/" +
      adminCorporateId,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
export const getB2BFilteredSessionInfo = async (
  token,
  adminCorporateId,
  department,
  location,
  gender
) => {
  if (store.getState().user.isDemoUser) {
    const sessionInfo =
      session.getB2BFilteredSessionInfo[gender].B2BSessionInfoData;
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    if (!sessionInfo[currentYear].monthlySessionData) {
      sessionInfo[currentYear].monthlySessionData = months.map((month) => ({
        name: month,
        uv: 0,
      }));
    }

    let totalSessionAdjustment = 0;
    for (let i = currentMonth + 1; i < 12; i++) {
      const monthName = months[i];
      const currentYearData = sessionInfo[currentYear].monthlySessionData.find(
        (month) => month.name === monthName
      );
      const allTimeDataIndex = sessionInfo[
        "All Time"
      ].monthlySessionData.findIndex((month) => month.name === monthName);

      if (currentYearData && allTimeDataIndex !== -1) {
        sessionInfo["All Time"].monthlySessionData[allTimeDataIndex].uv -=
          currentYearData.uv;
        totalSessionAdjustment += currentYearData.uv;
      }
    }
    sessionInfo["All Time"].totalSessions -= totalSessionAdjustment;

    if (sessionInfo[currentYear].monthlySessionData.length > 0) {
      sessionInfo[currentYear].monthlySessionData = sessionInfo[
        currentYear
      ].monthlySessionData.slice(0, currentMonth + 1);
    }

    return {
      data: {
        B2BSessionInfoData: sessionInfo,
        yearsArray: [2023, 2024],
      },
    };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/B2BSessionInfo/" +
          adminCorporateId +
          "?gender=" +
          gender,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getB2BFeedbacks = async (
  token,
  adminCorporateId,
  team,
  location,
  gender
) => {
  if (store.getState().user.isDemoUser) {
    const b2bFeedbacks = session.getB2BFeedbacks.feedbacks;
    // const result = b2bFeedbacks[team]["feedbacks"].concat(b2bFeedbacks[location]["feedbacks"],b2bFeedbacks[gender]["feedbacks"])
    return {
      data: {
        feedbacks: b2bFeedbacks,
      },
    };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/B2BFeedbacks/" +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getB2BMoodData = async (
  token,
  adminCorporateId,
  selectTimeRange,
  selectedTeam,
  selectedLocation
) => {
  if (store.getState().user.isDemoUser) {
    return { data: hr_overview.getB2BMoodData };
  } else {
    try {
      const params = {
        timeRange: selectTimeRange,
        teamName: selectedTeam,
        teamLocation: selectedLocation,
      };
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/B2BMoodData/" +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: params,
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getBlogData = async (token) =>
  await axios.get(process.env.REACT_APP_SERVER_URI + "/api/blogData", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getHomePageData = async () =>
  await axios.get(process.env.REACT_APP_SERVER_URI + "/api/homePageData");

export const submitContactFormData = async (data) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/contactFormData",
    data
  );

export const submitEmailForNewsLetter = async (data) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/emailForNewsLetter",
    data
  );

export const getMoodScoreData = async (
  token,
  adminCorporateId,
  department,
  location,
  gender,
  timeRange
) => {
  if (store.getState().user.isDemoUser) {
    const moodScoreData = hr_overview.getMoodScoreData.moodData;
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    moodScoreData[currentYear].moodScoreChartData = moodScoreData[
      currentYear
    ].moodScoreChartData.slice(0, currentMonth + 1);
    return {
      data: {
        moodData: moodScoreData,
        yearsArray: [2023, 2024],
      },
    };
  } else {
    try {
      const params = {
        teamName: department,
        teamLocation: location,
        gender: gender,
        timeRange: timeRange,
      };
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/moodScoreData/" +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: params,
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getAllAvatars = async (token) =>
  await axios.get(process.env.REACT_APP_SERVER_URI + "/api/allAvatars", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const redeemCoins = async (token, itemId, itemType) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/redeemCoins",
    {
      avatar_id: itemId,
      type: itemType,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getAssessmentData = async ({ month = "", year = "" }, token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      `/api/getAssessmentData?month=${month}&year=${year}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const fetchUserPlanner = async (userId, token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + `/api/user/${userId}/planner`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const fetchUserNotifications = async (token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + `/api/getnotifications`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const generateUserPlanner = async (token, userId, isFirst) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + `/api/user/${userId}/planner`,
    { isFirst: isFirst },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const regenerateUserPlanner = async (userId, token) =>
  await axios.patch(
    process.env.REACT_APP_SERVER_URI + `/api/user/${userId}/planner`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const markActivityComplete = async (token, userId, activityId) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI +
      `/api/user/${userId}/planner/activity/${activityId.toString()}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  export const getHRContentTrends = async (token, params) =>{
    try {
      let url =  process.env.REACT_APP_SERVER_URI + `/api/video-access-stats/?dateRange=${params.dateRange}`;
          // Add custom range if dateRange is "custom" and customDateRange is provided
      if (params.dateRange === "custom" && params.customDateRange) {
        if (Array.isArray(params.customDateRange)) {
          const [startDate, endDate] = params.customDateRange;
          if (startDate && endDate) {
            const startValue =
              startDate instanceof Date ? startDate.toISOString() : startDate;
            const endValue =
              endDate instanceof Date ? endDate.toISOString() : endDate;
            url += `&customStart=${encodeURIComponent(
              startValue
            )}&customEnd=${encodeURIComponent(endValue)}`;
          }
        } else {
          url += `&customDate=${encodeURIComponent(params.customDateRange)}`;
        }
      }
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
    );
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
}
